import { render, staticRenderFns } from "./LockLayout.vue?vue&type=template&id=35979eb5&"
import script from "./LockLayout.vue?vue&type=script&lang=js&"
export * from "./LockLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports